var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnvalidatedBullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    fill: "none",
    viewBox: "0 0 25 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13.003,
    r: 2.8391,
    fill: "#151515",
    stopColor: "#000000",
    strokeWidth: 0.62644
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnvalidatedBullet);
export default __webpack_public_path__ + "static/media/unvalidatedBullet.349b69828f8c2a6fcdb88fd8c5a23bc6.svg";
export { ForwardRef as ReactComponent };